import _util from '../utils';
import apiUrl from '../utils/api-url';
const axios = require('axios')
const productApi = {
  getAllSerieses(resolve, reject) {
    const current_lang = _util.getCurrentLang()
    let url = apiUrl.url + '/api/' + current_lang + '/series'
    axios.get(url)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  },

  getProducts(seriesId, resolve, reject) {
    const current_lang = _util.getCurrentLang()
    let url = ''
    if (seriesId) {
      url = apiUrl.url + '/api/' + current_lang + '/series/' + seriesId + '/products?per_page=10000'
    } else {
      url = apiUrl.url + '/api/' + current_lang + '/products?per_page=10000'
    }
    axios.get(url)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  },

  getProductDetail(productId, resolve, reject) {
    const current_lang = _util.getCurrentLang()
    let url = apiUrl.url + '/api/' + current_lang + '/products/' + productId
    axios.get(url)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  },

  getProductSizes(productId, resolve, reject) {
    const current_lang = _util.getCurrentLang()
    let url = apiUrl.url + '/api/' + current_lang + '/products/' + productId + '/size'
    axios.get(url)
      .then(function(response){
        resolve(response.data)
      })
      .catch(function(error){
        reject(error)
      })
  },

  getProductComments(productId, resolve, reject) {
    const current_lang = _util.getCurrentLang()
    let url = apiUrl.url + '/api/' + current_lang + '/products/' + productId + '/comments'
    axios.get(url)
      .then(function(response){
        resolve(response.data)
      })
      .catch(function(error){
        reject(error)
      })
  },

}

export default productApi



// WEBPACK FOOTER //
// ./src/api/product-api.js